// extracted by mini-css-extract-plugin
export var container = "index-module--container--LixWV";
export var description = "index-module--description--x7jAv";
export var flexContainer = "index-module--flexContainer--b4FgG";
export var image = "index-module--image--AMCh5";
export var section = "index-module--section--Fcc1h";
export var title = "index-module--title--2-u0d";